// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import PrivateRoute from "./components/Auth/PrivateRoute";
import AdminRoute from "./components/Auth/AdminRoute";
import AdminOrPermissionRoute from "./components/Auth/AdminOrPermissionRoute";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "@mui/icons-material/Add";
import "@mui/icons-material/Menu";
import "@mui/icons-material/DashboardOutlined";
import "@mui/icons-material/CodeOutlined";
import "@mui/icons-material/AddOutlined";
import "@mui/icons-material/PeopleOutlined";
import "@mui/icons-material/LogoutOutlined";

// Layout
import MainLayout from "./components/Layout/MainLayout";

// Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import BotList from "./pages/BotList";
import BotDetail from "./pages/BotDetail";
import NewBot from "./pages/NewBot";
import UserList from "./pages/UserList";
import UserDetail from "./pages/UserDetail";
import NotFound from "./pages/NotFound";

const theme = createTheme({
	palette: {
		primary: {
			main: "#6c5ce7",
			light: "#a29bfe",
			dark: "#5549c2",
		},
		secondary: {
			main: "#00cec9",
			light: "#81ecec",
			dark: "#00b1ad",
		},
		success: {
			main: "#55efc4",
			light: "#81f0d5",
			dark: "#00b894",
		},
		error: {
			main: "#ff7675",
			light: "#ff9f9e",
			dark: "#d63031",
		},
		background: {
			default: "#f8f9fa",
			paper: "#ffffff",
		},
	},
	typography: {
		fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
	},
	shape: {
		borderRadius: 8,
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none",
					fontWeight: 600,
				},
			},
		},
		MuiCard: {
			styleOverrides: {
				root: {
					boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.05)",
				},
			},
		},
	},
});

function App() {
	return (
		<ThemeProvider theme={theme}>
			<AuthProvider>
				<Router>
					<Routes>
						<Route path="/login" element={<Login />} />
						<Route path="/register" element={<Register />} />
						<Route
							path="/"
							element={
								<PrivateRoute>
									<MainLayout />
								</PrivateRoute>
							}
						>
							<Route index element={<Dashboard />} />
							<Route path="bots" element={<BotList />} />
							<Route
								path="bots/new"
								element={
									<AdminOrPermissionRoute permission="create_bot">
										<NewBot />
									</AdminOrPermissionRoute>
								}
							/>
							<Route path="bots/:id" element={<BotDetail />} />
							<Route
								path="admin/users"
								element={
									<AdminRoute>
										<UserList />
									</AdminRoute>
								}
							/>
							<Route
								path="admin/users/:id"
								element={
									<AdminRoute>
										<UserDetail />
									</AdminRoute>
								}
							/>
						</Route>
						<Route path="*" element={<NotFound />} />
					</Routes>
				</Router>
			</AuthProvider>
		</ThemeProvider>
	);
}

export default App;
